module.exports = __webpack_public_path__ + "img/Slice4-min.089de68d.png";